<template>
    <body class="min-h-fullscreen bg-home center-vh p-20" data-overlay="7">

  <div class="card px-50 py-30 w-600px mb-0">
    <div class="text-center">
      <img class="mb-10 logo-fitila" src="../../assets/static/fitila.png" alt="logo icon">
    </div>
    <h4><strong> SIGN UP</strong></h4>
    <p>You can have both listener and member account. First sign up as a user.</p>
    <p></p>    
          <form class="form-type-line">
            <div class="row">
              <div class="col-md-6">
                  <div class="form-group">
                    <label for="fname">First Name</label>
                    <input type="text" class="form-control" @blur="$v.fname.$touch()" v-model="fname" id="fname">
                    <div v-if="$v.fname.$dirty">
                      <div class="custom-error" v-if="!$v.fname.required">*Please enter your first name.</div>
                    </div>
                  </div>
              </div>
              <div class="col-md-6">
                  <div class="form-group">
                      <label for="lname">Last Name</label>
                      <input type="text" class="form-control" @blur="$v.lname.$touch()" v-model="lname" id="lname">
                      <div v-if="$v.lname.$dirty">
                        <div class="custom-error" v-if="!$v.lname.required">*Please enter your last name.</div>
                      </div>
                  </div>
              </div>
            </div>
                <div class="form-group">
                  <label for="email">Email</label>
                  <input type="text" class="form-control" id="email" @blur="$v.email.$touch()" v-model="email">
                  <div v-if="$v.email.$dirty">
                    <div class="custom-error" v-if="!$v.email.required">*Your email address is required.</div>
                    <div class="custom-error" v-if="!$v.email.email">*Please enter a valid email address.</div>
                  </div>
                </div>
            <div class="row">
              <div class="col-md-6">
                  <div class="form-group">
                    <label for="gender">Gender</label>
                    <multiselect v-model="gender" :options="['Male', 'Female']" @blur="$v.gender.$touch()"
                    :close-on-select="true" :show-labels="false" placeholder="Choose:">
                    </multiselect>
                    <div v-if="$v.gender.$dirty">
                      <div class="custom-error" v-if="!$v.gender.required">*Your gender is required.</div>
                    </div>
                  </div>
                </div>
                
              <div class="col-md-6">
                <div class="form-group">
                  <label for="email">Phone Number</label>
                  <input type="text" class="form-control py-10" id="phone"  v-model="phone">
                </div>
              </div>
            </div>
              
                  <div class="form-group">
                    <label for="nickname">Nickname<small class="pl-10">**Choose a nickname no one can identify you with.</small></label>
                    <input type="text" class="form-control" id="nickname" @blur="$v.nickname.$touch()" v-model="nickname">
                    <div v-if="$v.nickname.$dirty">
                      <div class="custom-error" v-if="!$v.nickname.required">*A nickname is required.</div>
                    </div>
                  </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="password">Password</label>
                    <input type="password" class="form-control" id="password" @blur="$v.password.$touch()" v-model="password">
                    <div v-if="$v.password.$dirty">
                      <div class="custom-error" v-if="!$v.password.required">*You need to set a password.</div>
                      <div
                        class="custom-error"
                        v-if="!$v.password.minLength"
                      >*Password must be at least {{$v.password.$params.minLength.min}} characters.</div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="confirm_password">Confirm Password</label>
                    <input type="password" class="form-control" id="confirm_password"  @blur="$v.confirm_password.$touch()" v-model="confirm_password">
                    <div v-if="$v.confirm_password.$dirty">
                      <div
                        class="custom-error"
                        v-if="!$v.confirm_password.sameAsPassword"
                      >*Passwords do not match.</div>
                    </div>
                  </div>
                </div>
              </div>
              <p class="fw-600 py-10">
                <input type="checkbox" id="checkbox" v-model="checked">
                **I agree that I am <span class="custom-color"> above 18 years of age</span>, I am not in crisis, homicidal, suicidal or abusing anyone and I agree to the FITILA 
                <a class="custom-color" href="https://mentalcare.life/terms">Terms of Service and Privacy Policy.</a>
              </p>
              <button class="btn btn-bold btn-block btn-primary" disabled v-if="loading">
                <circle-spin class="m-0"></circle-spin>
              </button>
              <button class="btn btn-bold btn-block btn-primary" v-else :disabled="$v.$invalid || !checked" @click="registerNewUser" type="button">SIGN UP</button>
          </form>

          <p class="text-center text-muted fs-13 mt-20">Already have an account? 
            <router-link tag="a" to="/" href="#" class="text-primary fw-500">
              Log in  
            </router-link>
          </p>

  </div>
</body>
</template>

<script>
import axios from "axios";
import {
  required,
  email,
  numeric,
  minLength,
  sameAs
} from "vuelidate/lib/validators";

export default {
  data() {
    return {
      loading: false,
      fname: "",
      lname: "",
      email: "",
      phone: "",
      gender: "",
      nickname: "",
      password: "",
      confirm_password: "",
      checked: false
    };
  },
  validations: {
    fname: { required },
    lname: { required },
    nickname: { required },
    email: {
      required,
      email
    },
    gender: {
      required
    },
    password: {
      required,
      minLength: minLength(8)
    },
    confirm_password: {
      sameAsPassword: sameAs("password")
    }
  }, 
  methods: {
    registerNewUser() {
      let userData = {
        firstname: this.fname,
        lastname: this.lname,
        email: this.email,
        phone: this.phone,
        password: this.password,
        gender: this.gender,
        nickname: this.nickname
      };
      this.loading = true
      axios.post('/users/signup', userData)
      .then(res => {
        this.loading= false
        this.$notify({
          group: 'response',
          type: 'success',
          title: 'Registration Successful',
          text: `${res.data.message}`,
          duration: 2500,
        });
        setTimeout(() => {
          this.$router.push('/')
        }, 3000)
      })
      .catch(err => {
        // console.log(err.response.data.message)
        this.loading= false
        this.$notify({
        group: 'response',
        type: 'error',
        title: 'Registration failed',
        text: `${err.response.data.message}`,
        duration: 5000       
      });
      })
    }
  },
};
</script>
